import { render, staticRenderFns } from "./jurisdiction.vue?vue&type=template&id=a9e3a09e&scoped=true&"
import script from "./jurisdiction.vue?vue&type=script&lang=js&"
export * from "./jurisdiction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9e3a09e",
  null
  
)

export default component.exports